/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const ClientOnboardingJob = {
    BrowseProfiles: 'browseProfiles',
    FindProfileUsingAi: 'findProfileUsingAi',
    InviteFreelancer: 'inviteFreelancer',
    CompanyFreelancers: 'companyFreelancers',
    DiscoverMaltStrategy: 'discoverMaltStrategy'
} as const;
export type ClientOnboardingJob = typeof ClientOnboardingJob[keyof typeof ClientOnboardingJob];


export function instanceOfClientOnboardingJob(value: any): boolean {
    for (const key in ClientOnboardingJob) {
        if (Object.prototype.hasOwnProperty.call(ClientOnboardingJob, key)) {
            // @ts-ignore
            if (ClientOnboardingJob[key] === value) {
                return true;
            }
        }
    }
    return false;
}

export function ClientOnboardingJobFromJSON(json: any): ClientOnboardingJob {
    return ClientOnboardingJobFromJSONTyped(json, false);
}

export function ClientOnboardingJobFromJSONTyped(json: any, ignoreDiscriminator: boolean): ClientOnboardingJob {
    return json as ClientOnboardingJob;
}

export function ClientOnboardingJobToJSON(value?: ClientOnboardingJob | null): any {
    return value as any;
}

